<template>
  <div class="main-page col-block" :style="{ flex: 1 }">
    <div class="main-container col-block width-full" :style="{ flex: 1, width: '100%', 'max-width': '1520px' }">
      <div :style="{ flex: 1 }"></div>
      <div class="main-block col-block flex-start">
        <div class="main-content-container col-block flex-start">
          <div class="main-content-title-container col-block flex-start">
            <img class="main-content-title-icon" :src="require('@/assets/images/main-logo.svg')" alt="">
            <div class="main-content-title">{{ $t('PAGE.main.___title') }}</div>
          </div>
          <div :style="{ height: '40px' }"></div>
          <div class="main-content-option-list-container col-block">
            <div class="main-content-option-list-block col-block stretch">
              <div class="main-content-option-container col-block width-full" v-for="(option, oindex) in linkOptions" :key="oindex" :style="{ '--size': '80px' }">
                <div class="main-content-option-block row-block" @click="e => siteOnSelected(option, saveSetting)">
                  <div class="main-content-option-tag-container center-block">
                    <div class="main-content-option-tag">{{ option.tag }}</div>
                  </div>
                  <div class="main-content-option-title-container" :style="{ flex: 1 }">
                    <div class="main-content-option-title ellipsis">{{ option.link }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div :style="{ height: '30px' }"></div>
            <div class="main-content-setting-container row-block">
              <div class="main-content-setting-block row-block" @click="e => saveSetting = !saveSetting">
                <img :src="saveSetting ? require('@/assets/images/checkbox-true.svg') : require('@/assets/images/checkbox-false.svg')" alt="">
                <div :style="{ width: '8px' }"></div>
                <div class="main-content-setting-title-container row-block">
                  <div class="main-content-setting-title">
                    <span>{{ $t('PAGE.main.setting.___title') }}</span>
                    <span>{{ ' (' }}</span>
                    <a class="link" @click.stop="e => clearSetting()">{{ $t('PAGE.main.setting.___clear') }}</a>
                    <span>{{ ')' }}</span>
                  </div>
                </div>
              </div>
              <div :style="{ width: '5px' }"></div>
              <div class="main-content-setting-info-container row-block">
                <borCor
                  :type="'top'"
                  :reverse="true"
                  :background="'white'"
                  :border="'#CCCCCC'"
                  :radius="'0px'"
                  :width="'350px'"
                  :blockStyle="{ padding: '8px' }"
                >
                  <template #trigger>
                    <div class="center-block">
                      <img :src="require('@/assets/icons/info-icon.svg')" alt="">
                    </div>
                  </template>
                  <template #content>
                    <div v-html="$t('PAGE.main.setting.___info')"></div>
                  </template>
                </borCor>
              </div>
            </div>
          </div>
          </div>
      </div>
      <div :style="{ flex: 2 }"></div>
    </div>
    <pageFooter></pageFooter>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getGeoCoding, postGeolocation } from '@/api'
import storage from '@/plugins/storage'
import pageFooter from '@/components/layout/pageFooter.vue'
import borCor from '@/components/tool/borCor.vue'
import localeData from '@/mixins/localeData.vue'
import { addToast } from '@/constants/global/toast'
import { regionOptions } from '@/constants/global/data'

export default {
  components: {
    pageFooter,
    borCor
  },
  mixins: [
    localeData
  ],
  data () {
    return {
      saveSetting: false
    }
  },
  computed: {
    // static
    linkOptions () {
      return regionOptions
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions([
      'addModalAction'
    ]),
    async init () {
      this.addModalAction()
      let savedRegion = storage.get('rememberRegion')
      if (regionOptions.some(option => option.value === savedRegion)) {
        this.saveSetting = true
        this.addModalAction({
          action: 'redirectAlert',
          style: {
            width: '468px'
          },
          params: {
            region: savedRegion,
            func: {
              'siteOnSelected': this.siteOnSelected,
              'clearSetting': this.clearSetting
            }
          }
        })
      } else {
        let currentRegion = await this.getCurrentRegion()
        if (currentRegion) {
          this.addModalAction({
            action: 'detectAlert',
            style: {
              width: '468px'
            },
            params: {
              region: currentRegion,
              func: {
                'siteOnSelected': this.siteOnSelected,
                'clearSetting': this.clearSetting
              }
            }
          })
        }
      }
    },
    async getCurrentRegion () {
      let geolocation = await this.getGeolocation()
      let geocoding = await this.getGeocoding(geolocation.lat, geolocation.lng)
      let country = this.getCountry(geocoding)
      if (!storage.get('locale')) {
        this.setAllLocale(['JP'].includes(country) ? 'ja' : 'en')
      }
      return regionOptions.some(option => option.value === country) ? country : null
    },
    async getGeolocation () {
      try {
        let geolocation = storage.get('geolocation')
        if (!geolocation) {
          let response = await postGeolocation()
          geolocation = response.data.location
          storage.set('geolocation', geolocation)
        }
        return geolocation
      } catch (error) {
        return null
      }
    },
    async getGeocoding (lat, lng) {
      try {
        let geocoding = storage.get('geocoding')
        if (!geocoding) {
          let response = await getGeoCoding(lat, lng)
          geocoding = response.data.results
          storage.set('geocoding', geocoding)
        }
        return geocoding
      } catch (error) {
        return null
      }
    },
    getCountry (results) {
      for (const result of results) {
        for (const comp of result.address_components) {
          if (comp.types.includes('country')) {
            return comp.short_name
          }
        }
      }
    },
    siteOnSelected (option, needSave = false) {
      needSave && storage.set('rememberRegion', option.value)
      window.location.href = 'https://' + option.link
    },
    clearSetting () {
      try {
        storage.remove('rememberRegion')
        addToast('success', 'COMMON.toast.___clearSetting')
      } catch (error) {
        addToast('error', 'COMMON.toast.___clearError')
      }
    }
  }
}
</script>
